// AUTO-GENERATED by scripts/gen-content-meta.ts — do not edit by hand.
/** slug -> lowest advertised THB price (starting price). */
export const SERVICE_PRICE_FROM: Record<string, number> = {
  "accounting-tax-monthly": 150,
  "airport-fast-track": 750,
  "apec-card": 2500,
  "bank-account-opening": 8500,
  "boi-application": 18500,
  "company-registration-thai": 15900,
  "contract-drafting-nda": 6500,
  "corporate-due-diligence": 120000,
  "council-architect": 4500,
  "council-engineer": 1500,
  "council-lawyer-bar": 1500,
  "council-nursing": 3500,
  "council-pharmacy": 1500,
  "council-teacher": 800,
  "driver-license-conversion": 200,
  "embassy-all-countries": 100,
  "embassy-legalization": 100,
  "expat-relocation-package": 25000,
  "foreign-business-license": 35000,
  "government-certification": 100,
  "insurance-o-a-ltr": 22000,
  "interpreter-academic": 4500,
  "interpreter-amphur": 500,
  "interpreter-business-consecutive": 5000,
  "interpreter-court": 3500,
  "interpreter-immigration": 3500,
  "interpreter-medical": 3000,
  "interpreter-property": 2500,
  "interpreter-remote": 2500,
  "interpreter-simultaneous": 8000,
  "marriage-abroad": 2500,
  "marriage-australia": 8000,
  "marriage-denmark": 5000,
  "marriage-france": 1000,
  "marriage-germany": 8000,
  "marriage-hongkong": 5000,
  "marriage-japan": 5000,
  "marriage-korea": 1000,
  "marriage-las-vegas": 3500,
  "marriage-netherlands": 1000,
  "marriage-new-zealand": 8000,
  "marriage-norway": 1000,
  "marriage-registration": 1500,
  "marriage-service": 4500,
  "marriage-singapore": 5000,
  "marriage-sweden": 1000,
  "marriage-switzerland": 1000,
  "marriage-taiwan": 5000,
  "marriage-uk": 4500,
  "medical-concierge": 1800,
  "medical-council": 800,
  "mfa-consular": 100,
  "mfa-consular-en": 100,
  "moj-translator": 300,
  "naati": 100,
  "naati-online": 100,
  "notary-affidavit": 600,
  "notary-apostille-poa": 1500,
  "notary-e-signature": 4500,
  "notary-oath-statutory": 600,
  "notary-poa-cross-border": 600,
  "notary-public": 1000,
  "notary-public-english": 1000,
  "pension-overseas": 1500,
  "police-bundle": 100,
  "police-clearance": 500,
  "police-clearance-intl": 100,
  "property-conveyancing-foreigner": 4500,
  "re-entry-permit": 1000,
  "residence-certificate": 3500,
  "school-placement": 1500,
  "sworn-austria": 600,
  "sworn-belgium": 600,
  "sworn-france": 600,
  "sworn-germany": 600,
  "sworn-italy": 1800,
  "sworn-netherlands": 600,
  "sworn-spain": 600,
  "sworn-switzerland": 600,
  "tat-license": 18500,
  "thai-visa": 800,
  "tm30-90day-report": 800,
  "trademark-madrid": 295,
  "translation-all": 100,
  "translation-certified-all": 100,
  "translation-government": 100,
  "translation-visa": 100,
  "treaty-of-amity": 18500,
  "visa-australia-600": 5000,
  "visa-business-b": 10000,
  "visa-canada": 3500,
  "visa-china-l": 4500,
  "visa-consult-foreign": 800,
  "visa-consult-thai": 1500,
  "visa-dependent": 3500,
  "visa-dtv": 8000,
  "visa-ed-student": 8000,
  "visa-elite": 300000,
  "visa-japan-tourist": 4500,
  "visa-korea-c3": 5500,
  "visa-ltr": 25000,
  "visa-marriage-o": 1500,
  "visa-metv": 3500,
  "visa-retirement": 1500,
  "visa-schengen": 800,
  "visa-smart": 15000,
  "visa-uk-visitor": 5000,
  "visa-us-b1b2": 3500,
  "will-inheritance": 8500,
  "work-experience-cert": 800,
  "work-permit": 800,
  "work-permit-amend": 150,
};

export function getPriceFrom(slug: string): number | undefined {
  return SERVICE_PRICE_FROM[slug];
}
